import store from "./../store";

export default class {
  constructor(http) {
    this.http = http;
  }

  //0 significa que esta fuera de hora
  //1 significa que non hay agentes disponibles
  //2 significa que no hay se paso del limite de la cola
  //3 significa que puede chatear

  newState(ontime, avaiableagents, avaiablesize) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = store.state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    let state = 0;
    if (ontime) {
      if (!avaiableagents) state = 1;
      else if (!avaiablesize) state = 2;
      else state = 3;
    }

    let savedstate = store.state[index].eventState;

    //si cambio el estado
    if (state !== savedstate) {
      store.commit("setEventState", state);

      //si no es que esta disponible
      if (state !== 3) {
        this.sendEvent(state);
      }
    }
  }

  sendEvent(state) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = store.state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    this.http
      .get(
        "https://" +
          store.state[index].configuration.ip +
          "/IntegraChannels/resources/webchat/sendEventLog",
        {
          params: {
            type: state,
            campaign: store.state[index].configuration.campaign,
            email: store.state[index].client.mail,
            name: store.state[index].client.name,
          },
        }
      )
      .then(
        (e) => {
          console.log(e);
        },
        (e) => {
          //error
          console.log(e);
        }
      );
  }
}
